import { render } from "./Localidad.vue?vue&type=template&id=51d80c3c&scoped=true"
import script from "./Localidad.vue?vue&type=script&lang=js"
export * from "./Localidad.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=51d80c3c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d80c3c"]])

export default __exports__